import type { CreateWizardContribution } from '../appModules';
import { useAppTypeModules } from '../appModules';

/**
 * Les formulaires de création maison des modules de type d'application
 * (`createWizard`) : la page « Créer » montre celui d'un modèle à la place
 * du formulaire du scaffolder (`useTemplateWizard`, `isWizardTemplatePath`).
 * Aucun sans module.
 */
export function useCreateWizards(): CreateWizardContribution[] {
  return useAppTypeModules().flatMap(module =>
    module.createWizard ? [module.createWizard] : [],
  );
}
